export default {
  computed: {
    routeIsHome () {
      return (this.$route.path === '/' || this.$route.path === '/en/')
    }
  }
}
